import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../../types';

const rootSelector = (state: RootState) => state.companiesInfo;
const accountSelector = (state: RootState) => state.auth.account.id;

const banksAccountsOptions = createSelector(rootSelector, (state) =>
  Object.values(state.banksAccounts).map((account) => ({
    label: `${account.accountNumber} в ${account.bankName}`,
    value: account.id.toString(),
  }))
);

const companiesSelector = createSelector(
  rootSelector,
  (state) => state.companies
);

const accountCompany = createSelector(
  [companiesSelector, accountSelector],
  (companies, accountId) => {
    if (accountId) {
      const foundCompany = Object.values(companies).find(
        (company) => company.accountIds.indexOf(accountId) !== -1
      );
      return foundCompany;
    }
    return undefined;
  }
);

export { banksAccountsOptions, accountCompany };
